module.exports = {
    title: `Whale's Blog`,
    description: `Somethong for your brain`,
    author: `WHALE`,
    introduction: `Fun Coding`,
    siteUrl: `https://whlae-blog.netlify.com`, // Your blog site url
    social: {
        twitter: ``, // Your Twitter account
        github: `wjy5446`, // Your GitHub account
        medium: ``, // Your Medium account
        facebook: `jaeyoung.yoon.940`, // Your Facebook account
        linkedin: `jaeyoung-yoon`, // Your LinkedIn account
    },
    icon: `content/assets/felog.png`, // Add your favicon
    keywords: [`blog`],
    comment: {
        disqusShortName: 'wjy5446', // Your disqus-short-name. check disqus.com.
        utterances: 'wjy5446/blog', // Your repository for archive comment
    },
    configs: {
        countOfInitialPost: 10, // Config your initial count of post
    },
    sponsor: {
        buyMeACoffeeId: 'jbee',
    },
    share: {
        facebookAppId: '', // Add facebookAppId for using facebook share feature v3.2
    },
    ga: '', // Add your google analytics tranking ID
}
